import React, { useEffect, useRef } from 'react';
import './JobTailoredResumeForm.css';

function JobTailoredResumeForm({ jobUrl, setJobUrl, resumeFile, handleFileChange, handleSubmit, isLoading }) {
  const fileInputRef = useRef(null);

  // Clear file input when resumeFile becomes null
  useEffect(() => {
    if (!resumeFile && fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }, [resumeFile]);

  return (
    <div className="job-tailored-form">
      
      <form onSubmit={handleSubmit}>
        <div className="job-tailored-form-group">
          <label>Job Post URL:</label>
          <input
            type="url"
            value={jobUrl}
            onChange={(e) => setJobUrl(e.target.value)}
            placeholder="https://example.com/job"
            required
          />
        </div>

        <div className="job-tailored-form-group">
          <label>Upload Your CV/Resume:</label>
          <input
            ref={fileInputRef}
            type="file"
            id="resume-upload"
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange}
            required
          />
        </div>

        <button type="submit" className="job-tailored-submit-btn" disabled={isLoading}>
          {isLoading ? 'Processing...' : 'Tailor My Resume'}
        </button>
      </form>
    </div>
  );
}

export default JobTailoredResumeForm;